<script>
import { mapActions, mapState } from 'pinia';
import { useSharedStore } from '@stores/shared.js';

export default {
    name: 'BreadcrumbsManager',
    computed: {
        ...mapState(useSharedStore, ['breadcrumbs'])
    },
    methods: {
        ...mapActions(useSharedStore, ['setBreadcrumbs']),
        /**
         * Handles navigation using the breadcrumbs
         * @param {Object} breadcrumb
         * @param {string} breadcrumb.name - Label of this breadcrumb.
         * @param {Object} breadcrumb.route - Route of this breadcrumb (has a .name and .params attribute)
         */
        navigateTo(breadcrumb, index) {
            if (index < this.breadcrumbs.length - 1) {
                // only keep breadcrumbs up to the breadcrumb that was passed
                const breadcrumbs = [...this.breadcrumbs].slice(0, index + 1);
                this.setBreadcrumbs(breadcrumbs);

                // navigate the user
                this.$router.push({
                    name: breadcrumb.route.name,
                    params: breadcrumb.route.params,
                    query: breadcrumb.route.query
                });
            }
        }
    }
};
</script>
